const container = document.querySelector(".container");
const items = document.querySelector(".items");
const indicator = document.querySelector(".indicator");
const itemElements = document.querySelectorAll(".item");
const previewImage = document.querySelector(".img__preview img");
const itemImages = document.querySelectorAll(".item img");

let isHorizontal = window.innerWidth <= 900;
let dimentions = {
  itemSize: 0,
  containerSize: 0,
  indecatorSize: 0,
};

let maxTranslate = 0;
let currentTranslate = 0;
let targetTranslate = 0;
let isClickMove = false;
let currentImageIndex = 0;
const activeItemOpacity = 0.3;

function lerp(start, end, factor) {
  return start + (end - start) * factor;
}

function updateDimention() {
  isHorizontal = window.innerWidth <= 900;

  if (isHorizontal) {
    dimentions = {
      itemSize: itemElements[0]?.getBoundingClientRect().width || 0,
      containerSize: items.scrollWidth,
      indecatorSize: indicator.getBoundingClientRect().width,
    };
  } else {
    dimentions = {
      itemSize: itemElements[0]?.getBoundingClientRect().height || 0,
      containerSize: items.getBoundingClientRect().height,
      indecatorSize: indicator.getBoundingClientRect().height,
    };
  }

  return dimentions;
}

dimentions = updateDimention();
maxTranslate = dimentions.containerSize - dimentions.indecatorSize;

function getItemIndicator() {
  itemElements.forEach((img) => (img.style.opacity = 1));

  const indecatorStart = -currentTranslate;
  const indecatorEnd = indecatorStart + dimentions.indecatorSize;

  let maxOverlap = 0;
  let selectedIndex = 0;

  itemElements.forEach((item, index) => {
    const itemStart = index * dimentions.itemSize;
    const itemEnd = itemStart + dimentions.itemSize;

    const overlapStart = Math.max(indecatorStart, itemStart);
    const overlapEnd = Math.min(indecatorEnd, itemEnd);
    const overlap = Math.max(0, overlapEnd - overlapStart);

    if (overlap > maxOverlap) {
      maxOverlap = overlap;
      selectedIndex = index;
    }
  });

  itemElements[selectedIndex].style.opacity = activeItemOpacity;
  return selectedIndex;
}

function updatePreviewImage(index) {
  if (currentImageIndex !== index) {
    currentImageIndex = index;
    const el = itemElements[index];
    if (!el) return;
    const targetItem = el.querySelector("img");
    const targetSrc = targetItem ? targetItem.getAttribute("src") : null;
    if (targetSrc && previewImage) previewImage.setAttribute("src", targetSrc);
  }
}

function animate() {
  // use a small easing value when not click-moving; when click-moving snap faster
  const lerpFactor = isClickMove ? 0.25 : 0.1;
  currentTranslate = lerp(currentTranslate, targetTranslate, lerpFactor);

  if (Math.abs(currentTranslate - targetTranslate) > 0.01) {
    const transform = isHorizontal
      ? `translateX(${currentTranslate}px)`
      : `translateY(${currentTranslate}px)`;
    items.style.transform = transform;

    const activeIndex = getItemIndicator();
    updatePreviewImage(activeIndex);
  } else {
    isClickMove = false;
  }

  requestAnimationFrame(animate);
}

container.addEventListener(
  "wheel",
  (e) => {
    e.preventDefault();
    isClickMove = false;

    let delta;
    delta = e.deltaY;

    const scrollVelocity = Math.min(Math.max(delta * 0.5, -20), 20);

    targetTranslate = Math.min(
      Math.max(targetTranslate - scrollVelocity, -maxTranslate),
      0
    );
  },
  { passive: false }
);

let touchStartY = 0;
// use touchstart rather than `touch` which is not a standard event
container.addEventListener("touchstart", (e) => {
  if (isHorizontal) {
    touchStartY = e.touches[0].clientY;
  }
});

container.addEventListener(
  "touchmove",
  (e) => {
    if (isHorizontal) {
      const touchY = e.touches[0].clientY;
      const deltaY = touchStartY - touchY;

      const delta = deltaY;
      const scrollVelocity = Math.min(Math.max(delta * 0.5, -20), 20);

      targetTranslate = Math.min(
        Math.max(targetTranslate - scrollVelocity, -maxTranslate),
        0
      );

      touchStartY = touchY;
      e.preventDefault();
    }
  },
  { passive: false }
);

itemElements.forEach((item, index) => {
  item.addEventListener("click", () => {
    isClickMove = true;
    targetTranslate =
      -index * dimentions.itemSize +
      (dimentions.indecatorSize - dimentions.itemSize) / 2;

    targetTranslate = Math.max(Math.min(targetTranslate, 0), -maxTranslate);
  });
});

window.addEventListener("resize", () => {
  dimentions = updateDimention();
  const newMaxTranslate = dimentions.containerSize - dimentions.indecatorSize;

  targetTranslate = Math.min(Math.max(targetTranslate, -newMaxTranslate), 0);
  currentTranslate = targetTranslate;

  const transform = isHorizontal
    ? `translateX(${currentTranslate})px`
    : `translateY(${currentTranslate})px`;
  items.style.transform = transform;
});

itemImages[0].style.opacity = activeItemOpacity;
updatePreviewImage(0);
animate();
